import { usePathname } from "next/navigation";

const useActiveMenu = () => {
  const pathname = usePathname();
  const isActive = (path: string) => path === pathname;
  
  return { isActive };
}

export default useActiveMenu;